// extracted by mini-css-extract-plugin
export var gif = "_jr-0";